import { html, css } from 'lit-element';
import { BaseElement } from './BaseElement';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';

class Connecting extends BaseElement {
	constructor() {
		super();

		this.library.add(faSpinner);
	}
	static get styles() {
		return [
			...BaseElement.styles,
			css`
				@keyframes spin {
					0% {
						-webkit-transform: rotate(0deg);
						transform: rotate(0deg);
					}
				
					100% {
						-webkit-transform: rotate(359deg);
						transform: rotate(359deg);
					}
				}
				.icon {
					animation: spin 1s linear infinite;
				}
			`
		];
	}
	render() {
		return html`
			<p>
				<i class="icon fas fa-spinner"></i>
				Connecting...
			</p>
		`;
	}
}

customElements.define('pp-connecting', Connecting);